//-----------Principal-----------
import Plantilla from '@/components/PaginaOficial/Comun/Plantilla.vue';

//-----------Lading Page-----------
import PaginaPrincipal from '@/components/PaginaOficial/PaginaPrincipal/Index.vue';
import PaginaInformativa from '@/components/PaginaOficial/PaginaInformativa/Index.vue';

//--------------Funciones--------------
import ConsultaDeAbogados from '@/components/PaginaOficial/Funciones/ConsultaDeAbogados/ConsultaDeAbogados.vue'
import PartidosJudiciales from '@/components/PaginaOficial/Funciones/PartidosJudiciales/PartidosJudiciales.vue'
import DirectorioDeInmuebles from '@/components/PaginaOficial/Funciones/DirectorioDeInmuebles/DirectorioDeInmuebles.vue'
import NotificacionElectronica from '@/components/PaginaOficial/Funciones/NotificacionElectronica/NotificacionElectronica.vue'
import VisualizarPDF from '@/components/PaginaOficial/PaginaPrincipal/VisualizarPdfDesdeDireccion.vue'
import VisorVideos from '@/components/PaginaOficial/PaginaPrincipal/VisorVideos.vue'
import VerificacionDePagos from '@/components/PaginaOficial/Funciones/VerificacionDePagos/VerificacionDePagos.vue'
import BusquedaVerificacionPagos from '@/components/PaginaOficial/Funciones/VerificacionDePagos/BusquedaVerificacionPagos.vue'
import VerificacionDeFirmas from '@/components/PaginaOficial/Funciones/VerificacionDeFirmas/VerificacionDeFirmas.vue'
import BusquedaVerificacionFirmas from '@/components/PaginaOficial/Funciones/VerificacionDeFirmas/BusquedaVerificacionFirmas.vue'
import ConvocatoriasFormulario from '@/components/PaginaOficial/PaginaInformativa/Convocatorias/ConvocatoriaAltaFormulario.vue'
import ConvocatoriasCreacionFormulario from '@/components/PaginaOficial/PaginaInformativa/Convocatorias/ConvocatoriasFormulario.vue'
import ConvocatoriasDisponibles from '@/components/PaginaOficial/PaginaInformativa/Convocatorias/ConvocatoriasDisponibles.vue'
import NuevasConvocatoriasDisponibles from '@/components/Convocatoria/NuevaConvocatoriaFormulario.vue'
import EdicionDeFormularioPorAspirante from '@/components/Convocatoria/EdicionDeFormularioPorAspirante.vue'
import ValidacionQR from '@/components/PaginaOficial/Funciones/ValidaDocumentoFirmado/VistaValidaDocumentoFirmadoQR.vue'

//Se crea la lista de paths
const PaginaOficial = [
  {
    path: '/', component: Plantilla, children: [
      { path: 'Inicio', component: PaginaPrincipal },
      { path: 'Web/:url', component: PaginaInformativa },
      { path: 'Funciones/ConsultaDeAbogadosRegistrados', component:  ConsultaDeAbogados, meta: { tituloDeLaPagina: "Consulta de Abogados" } },
      { path: 'Funciones/PartidosJudiciales', component:  PartidosJudiciales, meta: { tituloDeLaPagina: "Partidos Judiciales" } }, 
      { path: 'Funciones/DirectorioDeInmuebles', component:  DirectorioDeInmuebles, meta: { tituloDeLaPagina: "Directorio de Inmuebles" } },
      { path: 'Funciones/NotificacionElectronica', component:  NotificacionElectronica, meta: { tituloDeLaPagina: "Notificación Electrónica" } },
      { path: 'Ver/:url',component:VisualizarPDF,meta: { tituloDeLaPagina: "Visual" }},
      { path: 'Funciones/VerificacionDePagos', component: BusquedaVerificacionPagos, meta: { tituloDeLaPagina: "Verificación de Pagos"}},
      { path: 'Funciones/VerificacionDeFirmas', component: BusquedaVerificacionFirmas, meta: { tituloDeLaPagina: "Verificación de Firmas"}},
      {
        path: 'Funciones/ConvocatoriasDisponibles', component: ConvocatoriasDisponibles, meta: { tituloDeLaPagina: "Convocatorias  Disponibles" }
        
      },
      
    ]
  },
  { path: '/VerVideo/:video',component:VisorVideos},
  { path: '/Pagos/:VerificacionDePagos', component: VerificacionDePagos},
  { path: '/Firmas/:VerificacionDeFirmas', component: VerificacionDeFirmas},
  { path: '/Convocatorias/:pagina',component:ConvocatoriasCreacionFormulario,meta: { tituloDeLaPagina: "Visual" }},
  { path: '/Convocatorias', component: ConvocatoriasDisponibles,meta: {tituloDeLaPagina: "Convocatorias disponibles"} },
  { path: '/FormularioConvocatoria',   component: ConvocatoriasFormulario },
  { path: '/NuevaConvocatoriaFormulario', component: NuevasConvocatoriasDisponibles, meta: { tituloDeLaPagina: "Formulario Convocatoria PJ" } },
  { path: '/EdicionDeFormulario', component: EdicionDeFormularioPorAspirante, meta: { tituloDeLaPagina: "Formulario Convocatoria PJ" } },
  { path: '/Web/ValidacionDocumentoConFirma/:CodigoQR', component: ValidacionQR, meta:{tituloDeLaPagina: "Información de Documento con firma Electrónica"}}
  
];



//Se regresa la lista de paths
export default PaginaOficial


// WEBPACK FOOTER //
// ./src/router/PaginaOficial.js